import { triggerRefetchNav } from "../../../../../slices/navSlice";
import { setAdminPages } from "../../../../../slices/pageSlice";
import { postAPI } from "../../../../../API/ApiService";

export const modifiedArray = (arr) => {
  const newArr = arr?.map((item) => ({
    ...item,
    status: item.active ? "Active" : "Inactive",
    children:
      item.children?.map((child) => ({
        ...child,
        status: child.active ? "Active" : "Inactive",
      })) || [],
  }));
  return newArr;
};

export const handleRowOrderChange = async (
  url,
  payload,
  setLoading,
  dispatch
) => {
  setLoading(true);
  try {
    const response = await postAPI(url, payload);
    if (response?.status === 200) {
      const newArray = modifiedArray(response?.data);
      dispatch(setAdminPages(newArray));
      dispatch(triggerRefetchNav(true));
    }
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};
